import "./../topicStartegyBuilder/GetKeywordsTable.scss";

import {
  Card,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useMemo, useState } from "react";

interface Props {
  apiResponse: any[];
}

const ChannelAnalyzerTable = ({ apiResponse }: Props) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  } | null>({key:"channelRelevance", direction: "desc"});

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSort = (columnKey: string) => {
    if (sortConfig?.key === columnKey) {
      setSortConfig({
        key: columnKey,
        direction: sortConfig.direction === "asc" ? "desc" : "asc",
      });
    } else {
      setSortConfig({ key: columnKey, direction: "asc" });
    }
  };

  const sortedData = useMemo(() => {
    const sortableColumns = ["channelRelevance", "campaignRelevance", "clusterRelevance"];
    if (!sortConfig || !sortableColumns.includes(sortConfig.key)) return apiResponse;

    return [...apiResponse].sort((a, b) => {
      const aVal = a[sortConfig.key] ?? 0;
      const bVal = b[sortConfig.key] ?? 0;
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [apiResponse, sortConfig]);

  const getSortArrow = (key: string) => {
    if (sortConfig?.key !== key) return "";
    return sortConfig.direction === "asc" ? " ↑" : " ↓";
  };

  return (
    <Card className="secondtab-card-container">
      <Paper
        sx={{
          width: "100%",
          overflowX: "auto",
          scrollbarWidth: "thin",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <TableContainer
          sx={{
            maxHeight: 600,
            width: "100%",
            overflowX: "auto",
            "&::-webkit-scrollbar": {
              height: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#aaa",
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
            },
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Channel Name</TableCell>
                <TableCell
                  onClick={() => handleSort("channelRelevance")}
                  style={{ cursor: "pointer" }}
                >
                  Channel Relevance{getSortArrow("channelRelevance")}
                </TableCell>
                <TableCell>Campaign Name</TableCell>
                <TableCell
                  onClick={() => handleSort("campaignRelevance")}
                  style={{ cursor: "pointer" }}
                >
                  Campaign Relevance{getSortArrow("campaignRelevance")}
                </TableCell>
                <TableCell>Cluster</TableCell>
                <TableCell>Content Type</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Description</TableCell>
                <TableCell
                  onClick={() => handleSort("clusterRelevance")}
                  style={{ cursor: "pointer" }}
                >
                  Cluster Relevance{getSortArrow("clusterRelevance")}
                </TableCell>
                <TableCell>Related Keywords</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.channelName}</TableCell>
                    <TableCell>{row.channelRelevance}</TableCell>
                    <TableCell>{row.campaignName}</TableCell>
                    <TableCell>{row.campaignRelevance}</TableCell>
                    <TableCell>{row.cluster}</TableCell>
                    <TableCell>{row.contentType}</TableCell>
                    <TableCell>{row.title}</TableCell>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>{row.clusterRelevance}</TableCell>
                    <TableCell>{row.relatedKeywords}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[25, 50, 100]}
          component="div"
          count={apiResponse.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Card>
  );
};

export default ChannelAnalyzerTable;
